<template>
  <div>
    <div class="white px-3 pb-3 pt-0 mt-n2">
      <v-stepper :value="step" flat class="">
        <v-stepper-header>
          <template v-for="i in 5">
            <v-stepper-step :key="`st-${ i }`" :step="i" :complete="i < step" />
            <v-divider v-if="i < 5" :key="`d-${ i }`" />
          </template>
        </v-stepper-header>
      </v-stepper>

      <h2 class="text-center mt-n2">
        <slot name="header-text">
          Header text goes here
        </slot>
      </h2>

      <div class="mt-3 mx-3" style="line-height: 1.3">
        <slot name="header-body" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WizardStepHeader',

  props: ['step'],
}
</script>